import type { ReactNode } from "react";

/** Native disclosure keeps secondary controls accessible by keyboard without extra state. */
export function Disclosure({ title, children, open = false, className = "" }: { title: ReactNode; children: ReactNode; open?: boolean; className?: string }) {
  return <details className={`disclosure ${className}`} open={open || undefined}>
    <summary>{title}<span className="disclosure-arrow" aria-hidden="true">+</span></summary>
    <div className="disclosure-body">{children}</div>
  </details>;
}
